import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Initialize Sentry for error tracking
// import { initSentry } from "./lib/sentry";
// initSentry();

// CSS already handles hiding reCAPTCHA badge

createRoot(document.getElementById("root")!).render(<App />);
